const finbitManualScript = (() => {
    let linkedList, finbitConfigObj = {}, widget_service_api = '', document_upload_url = ''; 
    let supportedBanks = {};
    let promiseResolve; 
    let promiseReject;
    const finbitManualDefaultConfig = {
        uploadedDocsCount: 0
    };
    const MAX_FILE_COUNT = 12;
    let widgetPromise = new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;
    });
    let analyser_status = { "ignoreParsingError": false, "hideManualDiv":false, "skip_classify": false };

    /**
     * main : returning finbit-manual-template
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param obj object
     */
    const main = (obj) => {
        widget_service_api = obj.widget_service_api;
        document_upload_url = obj.document_upload_url;
        Object.assign(finbitConfigObj, obj.body);
        Object.assign(finbitManualDefaultConfig, obj);
        finbitManualDefaultConfig.slugs = obj.slugs || {};

        if(finbitManualDefaultConfig.body.analyser_status){
            analyser_status.ignoreParsingError = (true == finbitManualDefaultConfig.body.analyser_status.ignoreParsingError)?finbitManualDefaultConfig.body.analyser_status.ignoreParsingError : false;
            analyser_status.hideManualDiv = (true == finbitManualDefaultConfig.body.analyser_status.hideManualDiv)?finbitManualDefaultConfig.body.analyser_status.hideManualDiv : false;
            analyser_status.skip_classify = (true == finbitManualDefaultConfig.body.analyser_status.ignoreParsingError)?finbitManualDefaultConfig.body.analyser_status.ignoreParsingError : false;
            //analyser_status.skip_classify = (true == finbitManualDefaultConfig.body.analyser_status.skip_classify)?finbitManualDefaultConfig.body.analyser_status.skip_classify : false;
        }
        finbitManualDefaultConfig.security_option = finbitManualDefaultConfig.body["security"] || {};

        initOptions(finbitManualDefaultConfig.widget_service_api);

        linkedList = new LinkedList();
        const options = initScript.methodWiseOption(finbitManualDefaultConfig.options.finbit_manual_template.method, {
            url: finbitManualDefaultConfig.options.finbit_manual_template.url,
            data: JSON.stringify((finbitConfigObj && finbitConfigObj.html) ? finbitConfigObj.html : {}),
            headers: { "Content-Type": "application/json" },
            processData: false
        }, finbitManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            res = (typeof res === "string") ? res : responseV2Interceptor(res, finbitManualDefaultConfig.slugs["finbit-manual-template"], false);
            get_supported_banks();
            appendTemplate(res);
        });
    };

    /**
     * get_supported_banks : get_supported_banks
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const get_supported_banks = () => {
        const options = initScript.methodWiseOption(finbitManualDefaultConfig.options.finbit_supported_banks.method, {
            url: finbitManualDefaultConfig.options.finbit_supported_banks.url
        }, finbitManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            res = (typeof res === "string") ? res : responseV2Interceptor(res, finbitManualDefaultConfig.slugs["finbit-supported-banks"], false);
            Object.assign(supportedBanks, res);
        });
    };

    /**
     * initOptions : initializing option config
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param API_URL string
     */
    const initOptions = (API_URL) => {
        finbitManualDefaultConfig.options = {
            finbit_manual_template: {
                url: getV2URL(API_URL, "finbit-manual-template", finbitManualDefaultConfig.slugs),
                method: "POST",
            },
            finbit_supported_banks: {
                url: getV2URL(API_URL, "finbit-supported-banks", finbitManualDefaultConfig.slugs),
                method: "POST",
            },
            finbit_document_upload: {
                url: getV2URL(document_upload_url ? document_upload_url : API_URL, "finbit-document-upload", finbitManualDefaultConfig.slugs),
                // url: getV2URL(API_URL, "finbit-document-upload", finbitManualDefaultConfig.slugs),
                method: "POST",
            },
            // finbitTransactionIds: {
            //     url: getV2URL(API_URL, "finbitTransactionIds", finbitManualDefaultConfig.slugs),
            //     method: 'GET',
            // },
            // submitfinbitForm: {
            //     url: getV2URL(API_URL, "submitfinbitForm", finbitManualDefaultConfig.slugs),
            //     method: 'POST',
            // },
            // classifyDocs: {
            //     url: getV2URL(API_URL, "classify-docs", finbitManualDefaultConfig.slugs),
            //     method: 'POST'
            // },
            // openfinbitModel: {
            //     // url: API_URL + '/openfinbitModel' + '?internal=true',
            //     url: getV2URL(API_URL, "openfinbitModel", finbitManualDefaultConfig.slugs),
            //     method: 'GET'
            // },
            finbitParsingUploadedDocs: {
                url: getV2URL(API_URL, "finbit-parsing-uploaded-docs", finbitManualDefaultConfig.slugs, finbitManualDefaultConfig.ignoreSlugs),
                method: 'POST'
            },
            // classifyUploadedDocs: {
            //     url: getV2URL(API_URL, "classify-uploaded-docs", finbitManualDefaultConfig.slugs),
            //     method: 'POST'
            // },
            deleteuploadeddocsmanualreference: {
                url: getV2URL(API_URL, "delete-uploaded-docs-manual-reference", finbitManualDefaultConfig.slugs),
                method: 'POST'
            },
            deleteUploadedDocsBusiness: {
                url: getV2URL(API_URL, "deleteUploadedDocsBusiness", finbitManualDefaultConfig.slugs),
                method: 'POST'
            },
            deleteUploadedDocsManual: {
                url: getV2URL(API_URL, "deleteUploadedDocsManual", finbitManualDefaultConfig.slugs),
                method: finbitManualDefaultConfig.slugs.deleteUploadedDocsManual? "POST" : "DELETE",
            }
        };
    };

    /**
     * toggleTargetProperty : disabling target elements by property
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param flag boolean
     * @param hideFile boolean
     */
    const toggleTargetProperty = (flag = true, hideFile = false) => {
        flag = (linkedList.size_of_list() === 0) | flag;
        if (hideFile) {
            initScript.disableElementByProp('#fileCall', hideFile);
            initScript.getHTMLElementByDelimiter('widgetLoaderWrapper').remove();
            initScript.disableElementByProp('#uploadFileID', flag);
        }
        initScript.disableElementByProp('#submitUploadedFilesId', flag);
    };

    /**
     * appendTemplate : appending template on finbitManual class
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param template string
     */
    const appendTemplate = (template) => {
        $(`.${finbitConfigObj.class}`)[0].innerHTML = template;
        bindTemplateFunctions();
        initScript.toggleLoader(false);
        // Google.init(finbitManualDefaultConfig);
    };

    /**
     * uploadFile : uploading a single file
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param file File
     * @param requestOptions robject
     * @param callback Function
     */
    const uploadFile = (file, requestOptions, callback) => {
        HttpRequest(requestOptions, res => {
            res = typeof res === "string" ? JSON.parse(res) : res;
            res = responseV2Interceptor(res, finbitManualDefaultConfig.slugs["finbit-document-upload"]);
            appendFilesToList(file, res.ref_id);
            callback(res);
        });
    };

    /**
     * uploadFiles : uploading multiple files
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param files File
     */
    const uploadFiles = (files) => {
        initScript.toggleLoader(true);
        hideNonPDFErrorMessage();
        finbitManualDefaultConfig.uploadedDocsCount = 0;
        for (let i = 0; i < files.length; ++i) {
            const form = new FormData();
            if (widget_service_api.search(/orch/gm) !== -1 && !Object.keys(finbitManualDefaultConfig.slugs).length) {
                form.append("file_name", files[i]);
                form.append("filekey", 'file');
            } else form.append("file", files[i]);
            form.append("user_id", finbitConfigObj.user_id);
            form.append("app_id", finbitConfigObj.app_id);
            form.append("provider[auto]", finbitConfigObj.provider['auto']);
            form.append("provider[manual]", finbitConfigObj.provider['manual']);
            form.append("provider[document-management]", finbitConfigObj.provider['document-management']);
            form.append("type", "file");
            form.append("mimeType", 'multipart/form-data');
            form.append("doc_type_id", finbitConfigObj.doc_type_id);
            if(finbitConfigObj.doc_type_key){
                form.append("doc_type_key", finbitConfigObj.doc_type_key);
            }

            const options = initScript.methodWiseOption(finbitManualDefaultConfig.options.finbit_document_upload.method, {
                url: finbitManualDefaultConfig.options.finbit_document_upload.url,
                mimeType: "multipart/form-data",
                data: form,
                processData: false,
                contentType: false
            }, finbitManualDefaultConfig.security_option);
          
            if (files[i].type == 'application/pdf' || analyser_status.ignoreParsingError) {
                uploadFile(files[i], options, res => {
                    finbitManualDefaultConfig.uploadedDocsCount++;
                    res = responseInterceptor(res);
                    if (!!res.code && res.code >= 400) {
                        initScript.getTargetIdentifierElement('#Failure').innerHTML =  res.errors[0].message;
                        initScript.getHTMLElementByDelimiter('Failure', '#').css('display', 'block');
                        // showNonPDFErrorMessage();
                        initScript.toggleLoader(false);
                    } else if (finbitManualDefaultConfig.uploadedDocsCount === files.length) initScript.toggleLoader(false);
                });
            }else{
                showNonPDFErrorMessage();
                initScript.toggleLoader(false);
            }
        }
    };

    /**
     * getDownloadedFile : getting uploading files data
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const getDownloadedFile = () => {
        initScript.toggleLoader(true);
        const query = initScript.generateQueryParams({
            app_id: finbitConfigObj.app_id,
            user_id: finbitConfigObj.user_id,
            provider: finbitConfigObj.provider['document-management']
        });

        const options = initScript.methodWiseOption('GET', {
            url: widget_service_api + '/getDownloadedFile' + '?' + query + '?internal=true'
        }, finbitManualDefaultConfig.security_option);

        HttpRequest(options, res => {
            res = responseInterceptor(res);
            // extractDownloadedFiles(res);
        });
    };

    /**
     * downloadFile : downloading file with required parameters
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param doc_id string
     * @param callback Function
     */
    const downloadFile = (doc_id, callback) => {
        const options = initScript.methodWiseOption('GET', {
            url: widget_service_api + '/downloadFile/' + doc_id + '?internal=true',
        }, finbitManualDefaultConfig.security_option);

        HttpRequest(options, res => {
            res = responseInterceptor(res);
            callback(res);
        });
    };

    /**
     * extractDownloadedFiles : downloading file and showing on list
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param downloadedFileResponse string
     */
    const extractDownloadedFiles = (downloadedFileResponse) => {
        if (!!!downloadedFileResponse || !!!downloadedFileResponse.data || !!!downloadedFileResponse.data.length) initScript.toggleLoader(false);
        let count = 0;
        for (let i = 0; i < downloadedFileResponse.data.length; ++i) {
            downloadFile(downloadedFileResponse.data[i].ref_id, res => {
                if (!!res && !!res.data) {
                    /*initScript.urlToFile('data:application/pdf;base64,' + res.data, downloadedFileResponse.data[i].response.data.filename, 'application/pdf').then(file => {
                        linkedList.add(file, downloadedFileResponse.data[i].ref_id);
                        showFilesList(downloadedFileResponse.data[i].response.data.filename, linkedList.size_of_list() - 1);
                        if (++count === downloadedFileResponse.data.length) initScript.toggleLoader(false);
                    });*/
                }
            });
        }
    };

    /**
     * appendFilesToList : appending file on list
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param file File
     * @param id string
     */
    const appendFilesToList = (file, id) => {
        if (file.name.split('.')[file.name.split('.').length - 1] !== 'pdf' && false == analyser_status.ignoreParsingError) return;
        linkedList.add(file, id);
        showFilesList(file, linkedList.size_of_list() - 1, id);
    };

    /**
     * analyserUploadedDocsUtil : analysing uploaded doc
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param file File
     * @param doc_id string
     */
    const analyserUploadedDocsUtil = (formdata) => {
        hideNonPDFErrorMessage();
        initScript.getHTMLElementByDelimiter('doneMessageID', '#').css('display', 'none');
        var securityOpts = finbitManualDefaultConfig.security_option;
        securityOpts.headers["x-multiple-upload"] = MAX_FILE_COUNT;
        const options = initScript.methodWiseOption(finbitManualDefaultConfig.options.finbitParsingUploadedDocs.method, {
            url: finbitManualDefaultConfig.options.finbitParsingUploadedDocs.url,
            mimeType: "multipart/form-data",
            data: formdata,
            processData: false,
            contentType: false
        }, securityOpts);

        return new Promise((resolve, reject) => {
            HttpRequest(options, (res) => {
                res = typeof res === "string" ? JSON.parse(res) : res;
                let result = responseV2Interceptor(res,finbitManualDefaultConfig.slugs['finbit-parsing-uploaded-docs']);
                if(result.analyserResponse.errors){
                    reject(result);
                }
                else{
                    // initScript.getTargetIdentifierElement('#doneMessageID').innerHTML =  'Thanks for submitting your details, Please close the browser.';
                    // document.getElementById("doneMessageID").style.color = "black";
                    resolve(result);
                }
            });
        });
    };

    /**
     * analyserUploadedDocs : analysing uploaded docs
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const analyserUploadedDocs = () => {
        var tasks = [];
        var filekeys = {};
        var formData = new FormData();
        // formData.append("filekey", 'file');
        formData.append("user_id", finbitConfigObj.user_id);
        formData.append("app_id", finbitConfigObj.app_id);
        formData.append("provider[auto]", finbitConfigObj.provider['auto']);
        formData.append("provider[manual]", finbitConfigObj.provider['manual']);
        formData.append("provider[document-management]", finbitConfigObj.provider['document-management']);
        formData.append("type", "file");

        for (let i = 0; i < linkedList.size_of_list(); ++i) {
            const node = linkedList.getAt(i);
            formData.append('statement.'+i+'.bank', $('input[name="statement['+node.id+'][bank]"]').val())
            formData.append('statement.'+i+'.accountType', $('select[name="statement['+node.id+'][accountType]"]').val())
            formData.append('statement.'+i+'.pdfType', $('select[name="statement['+node.id+'][pdfType]"]').val())
            formData.append('statement.'+i+'.doc_id', node.id);
            formData.append('multiple.'+i+'.file', node.val);
            // formData.append("filekey", 'statement.'+i+'.bankStmt');
            filekeys['multiple.'+i+'.file'] = 'statement.'+i+'.bankStmt';
            // tasks.push(node.val)
        }
        formData.append("filekeys", JSON.stringify(filekeys))
        return Promise.all([analyserUploadedDocsUtil(formData)]);
    };

    /**
     * classifyUploadedDocs : classify uploaded docs
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const classifyUploadedDocs = () => {
        const options = initScript.methodWiseOption(finbitManualDefaultConfig.options.classifyUploadedDocs.method, {
            url: finbitManualDefaultConfig.options.classifyUploadedDocs.url,
            data: {
                user_id: finbitConfigObj.user_id,
                app_id: finbitConfigObj.app_id,
                provider: {
                    auto: finbitConfigObj.provider['auto'],
                    manual: finbitConfigObj.provider['manual'],
                    'document-management': finbitConfigObj.provider['document-management'],
                },
                type: finbitConfigObj.type,
                doc_type_id: finbitConfigObj.doc_type_id,
                skip_classification: analyser_status.skip_classify
            }
        }, finbitManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            initScript.toggleLoader(false);
            $('#doneMessageID').css('display', 'block');
            toggleTargetProperty(true, true);
            $(".close").off("click");
            promiseResolve({
                code: 200,
                type: 'manual',
                status: 'success',
                data: res
            });
        });
    };

    /**
     * deleteSelectedFileManual : deleting doc from manual
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param idx number
     * @param flag boolean
     */
    const deleteSelectedFileManual = (idx, flag = false) => {
        initScript.toggleLoader(true);
        const linkedListNode = linkedList.getAt(idx);
        const nodeIndexToDelete = linkedList.searchNodeIndexById(linkedListNode.id)
        const query = initScript.generateQueryParams({
            doc_id: linkedListNode.id
        });
        const options = initScript.methodWiseOption(finbitManualDefaultConfig.options.deleteUploadedDocsManual.method, {
            url: finbitManualDefaultConfig.slugs.deleteUploadedDocsManual ?  finbitManualDefaultConfig.options.deleteUploadedDocsManual.url + '&' + query:  widget_service_api + "/deleteUploadedDocsManual/" + linkedListNode.id + '?internal=true',
        }, finbitManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            initScript.getTargetIdentifierElement('#Failure').innerHTML =  '';
            res = responseV2Interceptor(res, finbitManualDefaultConfig.slugs["deleteUploadedDocsManual"]);
            if (!flag) initScript.toggleLoader(false);
            if (res.code !== 400 || res.data.code !== 400) {
                deleteSelectedBusinessFile(idx, linkedListNode.id, nodeIndexToDelete);
            }
        });
    };

    /**
     * deleteSelectedFileManual : deleting doc from business
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param idx number
     * @param id string
     */
    const deleteSelectedBusinessFile = (idx, id, nodeIndexToDelete) => {
        const options = initScript.methodWiseOption('POST', {
            url: finbitManualDefaultConfig.options.deleteUploadedDocsBusiness.url,
            // url: widget_service_api + "/deleteUploadedDocsBusiness" + '?internal=true',
            data: {
                doc_id: id
            }
        }, finbitManualDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            linkedList.removeFrom(nodeIndexToDelete);
            toggleTargetProperty(!!!linkedList.size_of_list());
            $('#uploadedFile' + idx).remove();
            document.getElementById('fileButton').value = "";
            initScript.toggleLoader(false);
        });
    };

    /**
     * deleteSelectedFileManual : displaying files
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param file File
     * @param idx number
     */
    const showFilesList = (file, idx, docId) => {
        const deleteIcon = (finbitManualDefaultConfig.body.html.icons && finbitManualDefaultConfig.body.html.icons.delete) ? finbitManualDefaultConfig.body.html.icons.delete : '&#9746;';
        toggleTargetProperty(!!!linkedList.size_of_list());
        const uploadedFiles = $('.uploadedFiles');
        uploadedFiles.append('<tr class="row" id="uploadedFile' + idx + '" data-val="' + idx + '">'+
                                '<td class="col"><span class="gtc fwb">'+file.name+'</span><input type="hidden" value="'+docId+'" name="statement['+docId+'][doc_id]"></td>'+
                                '<td class="col">'+
                                    '<input type="hidden" class="widget_bankName" name="statement['+docId+'][bank]" id="'+docId+'bank" required>'+
                                    '<input name="bank'+docId+'" class="widget_bankSelector form-control" id="'+docId+'selector" autocomplete="off" required>'+
                                '</td>'+
                                '<td class="col">'+
                                    '<select name="statement['+docId+'][accountType]" class="form-control" required>'+
                                        '<option value="" selected disabled hidden>-Account Type-</option>'+
                                        '<option value="SAVING">Savings Account</option>'+
                                        '<option value="CURRENT">Current Account</option>'+
                                        '<option value="CREDIT_CARD">Credit Card</option>'+
                                        '</select>'+
                                '</td>'+
                                '<td class="col">'+
                                    '<select name="statement['+docId+'][pdfType]" class="form-control" required>'+
                                        '<option value="" selected disabled hidden>-PDF Type-</option>'+
                                        '<option value="native">Original / Native</option>'+
                                        '<option value="scanned">Scanned</option>'+
                                    '</select>'+
                                '</td>'+
                                '<td class="col-2 mt-2">'+
                                    '<a href="javascript:void(0)" title="Delete" id="deleteSelectedBusinessFileID' + idx + '">'+deleteIcon+'</a>'+
                                    '<!-- <a class="ml-3" href="javascript:void(0)" title="Download" triggers="mouseenter:mouseleave">&#8681;</a> -->'+
                                '</td>'+
                            '</tr>');
        $('#deleteSelectedBusinessFileID' + idx).on('click', () => {
            if(confirm("Are you sure you want to delete this file?")){
                deleteSelectedFileManual(idx, true);
            }
        });
        $(document).on('keydown.autocomplete', "#"+docId+"selector", function() {
            $(this).autocomplete({
                source: supportedBanks.finbitBanksList,
                minLength: 0,
                select: function( event, ui ) {
                    $("#"+docId+"bank").val(ui.item.key)
                    $(this).val(ui.item.value)
                    return false;
                }
              }).focus(function(){            
                $(this).data("uiAutocomplete").search($(this).val());
            });
        });
    };

    /**
     * hideNonPDFErrorMessage : hide none error message
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const hideNonPDFErrorMessage = () => {
        finbitManualDefaultConfig.nonPDFFileErrorMessage.css('display', 'none');
    };
    /**
     * showNonPDFErrorMessage : show none error message
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const showNonPDFErrorMessage = () => {
        finbitManualDefaultConfig.nonPDFFileErrorMessage.css('display', 'block');
        // autoCallAFunctionByExpectedTime();
    };
    /**
     * autoCallAFunctionByExpectedTime : call a function after given time
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const autoCallAFunctionByExpectedTime = (time = 10000) => {
        setTimeout(() => {
            hideNonPDFErrorMessage();
        }, time)
    };
    /**
     * bindClickEvents : binding target identifiers click events
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const bindClickEvents = () => {
    };
    /**
     * bindTemplateFunctions : binding target identifiers
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const bindTemplateFunctions = () => {
        toggleTargetProperty();
        const dragBox = $('.dragBox');
        dragBox.on("dragover", function (event) {
            event.preventDefault();
            event.stopPropagation();
        });

        dragBox.on("dragleave", function (event) {
            event.preventDefault();
            event.stopPropagation();
        });

        dragBox.on("drop", function (event) {
            event.preventDefault();
            event.stopPropagation();
            uploadFiles(event.originalEvent.dataTransfer.files);
        });
        $('#submitUploadedFilesId').on('click', () => {
            submitFiles();
        });
        $('.closefinbitManualUploadModal').on('click', () => {
            hideManualDiv(finbitConfigObj.class, finbitConfigObj.html.modal);
        });
        $("."+finbitConfigObj.class+' :input[type="file"]').change(function (e) {
            $("#formErrorHTML5").hide();
            var totalTargetFiles = e.target.files.length + linkedList.size_of_list();
            if(MAX_FILE_COUNT >= totalTargetFiles){
                uploadFiles(e.target.files);
            }
            else{
                var tmsg = (finbitManualDefaultConfig?.body?.html?.max_upload_limit_message)?finbitManualDefaultConfig.body.html.max_upload_limit_message: "Upload max 12 documents only."
                throwErrMessage(tmsg);
            }
        });
        finbitManualDefaultConfig.submitUploadedFilesId = initScript.getHTMLElementByDelimiter('submitUploadedFilesId', '#');
        finbitManualDefaultConfig.nonPDFFileErrorMessage = initScript.getHTMLElementByDelimiter('nonPDFFileErrorMessage');
        initScript.appendCSS(finbitConfigObj);
        bindClickEvents();
        // getDownloadedFile();
    };

    /**
     * deleteManualReferences : deleting manual references
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const deleteManualReferences = () => {
        initScript.toggleLoader(true);
        const options = initScript.methodWiseOption('POST', {
            url: finbitManualDefaultConfig.options.deleteuploadeddocsmanualreference.url,
            url: widget_service_api + "/delete-uploaded-docs-manual-reference" + '?internal=true',
            method: "POST",
            data: {
                user_id: finbitConfigObj.user_id,
                app_id: finbitConfigObj.app_id,
                provider: {
                    auto: finbitConfigObj.provider['auto'],
                    manual: finbitConfigObj.provider['manual']
                }
            }
        }, finbitManualDefaultConfig.security_option);

        return new Promise((resolve, reject) => {
            HttpRequest(options, (res) => {
                resolve(res);
            });
        });
    };

    /**
     * submitFilesUtil : analyse and classify uploaded docs
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const submitFilesUtil = () => {
        analyserUploadedDocs().then(res2 => {
            initScript.toggleLoader(false);
            $('#doneMessageID').css('display', 'block');
            toggleTargetProperty(true, true);
            $("#finbitform select, #finbitform input, #fileButton, #submitUploadedFilesId").attr("disabled", true);
            $(".close").off("click");
            promiseResolve({
                code: 200,
                type: 'finbit-manual',
                status: 'success',
                data: res2
            });
            return;
            // return classifyUploadedDocs();
        }).catch(err => {
            initScript.toggleLoader(false);
            if(analyser_status.ignoreParsingError){ //Ignore error for analyser
                $('#doneMessageID').css('display', 'block');
                toggleTargetProperty(true, true);
                $(".close").off("click");
                promiseResolve( { code: 200, type: 'analyser-response', status: 'success', data: err} );
                if(analyser_status.hideManualDiv){
                    hideManualDiv(finbitConfigObj.class, finbitConfigObj.html.modal);
                }
            }
            else{ //Display error for analyser
                var err_msg = "Unable to parse."
                // err_msg += (err.analyserResponse.errors["invalid_data"])? "\n\r "+err.analyserResponse.errors["invalid_data"]: "";
                initScript.getTargetIdentifierElement('#Failure').innerHTML =  err_msg;
                initScript.getHTMLElementByDelimiter('Failure', '#').css('display', 'block');
                // document.getElementById("doneMessageID").style.color = "red";   
                // promiseReject( {code: 400, type: 'analyser-response', status: 'failure', data: err.analyserResponse} )
            }
        });
    };

    /**
     * submitFiles : submit uploaded docs for analyser and classify
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */
    const submitFiles = () => {
        if (!$('#finbitform')[0].checkValidity() || isFormInValid()) { throwErrMessage(); return; }
        $("#formErrorHTML5").hide(); 
        if (!linkedList.size_of_list()) return;
        initScript.toggleLoader(true);
        if (!!finbitManualDefaultConfig.body.delete_uploaded_docs_ref) {
            deleteManualReferences().then(res1 => {
                submitFilesUtil();
            });
        } else submitFilesUtil();
    };

    /**
     * hideManualDiv : hide manual div modal
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param templateClass string
     * @param templateModalOption object
     */
    const hideManualDiv = (templateClass, templateModalOption) => {
        if (templateModalOption !== 'none') {
            $(`.${templateClass}`)[0].innerHTML = '';
            $(`.${templateClass}`).removeAttr('style');
        }
    };

    const throwErrMessage = (toast = false) => {
        if(!toast){
            $("#formErrorHTML5").html(finbitManualDefaultConfig.body.html.upload_form_error_message);
        }
        else{
            $("#formErrorHTML5").html(toast);
        }
        $("#formErrorHTML5").show();
    };

    const isFormInValid = () => {
        $(".widgetFormError").removeClass("widgetFormError")
        var err = 0;
        $(".widget_bankName").each(function(control) {
            var valMatch = $(this).next().val();
            var match = supportedBanks.finbitBanksList.find(o => o.key === $(this).val());
            if(!match || match.value !== valMatch){ 
                $(this).next().addClass("widgetFormError")
                err++;
            }
        });
        return (err === 0)?false:true;
    }

    return {
        main,
        widgetPromise,
        uploadFiles
    };
})();
